import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthLayout } from "@/layouts/AuthLayout";
import { Turnstile } from "@/components/ui/Turnstile";
import { useAuth } from "@/hooks/useAuth";
import { useAuthConfig } from "@/hooks/useAuthConfig";

export function RegisterPage() {
  const { register } = useAuth();
  const cfg = useAuthConfig();
  const nav = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [invite, setInvite] = useState("");
  const [email, setEmail] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const needsInvite = cfg && !cfg.open_registration;
  const needsCaptcha = !!cfg?.captcha_sitekey;
  const canSubmit =
    u.length >= 3 &&
    p.length >= (cfg?.min_password_len ?? 8) &&
    (!needsInvite || invite.trim().length > 0) &&
    (!needsCaptcha || captcha.length > 0) &&
    !busy;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      await register(u, p, invite || undefined, email || undefined, captcha || undefined);
      nav("/", { replace: true });
    } catch (ex) {
      const msg = ex instanceof Error ? ex.message : "Inscription échouée";
      setErr(msg.replace(/^api\s+/i, ""));
    } finally { setBusy(false); }
  };

  const inputStyle = { padding: 12, background: "var(--bg-elev-2)",
                       border: "1px solid var(--line)", borderRadius: 8, color: "var(--fg)" };

  return (
    <AuthLayout>
      <h1 style={{ marginTop: 0 }}>Créer un compte</h1>
      <form onSubmit={submit} className="stack" style={{ gap: 12 }}>
        <input placeholder="Nom d'utilisateur (3 caractères min)" value={u}
               onChange={(e) => setU(e.target.value)} required minLength={3} maxLength={64}
               autoComplete="username" style={inputStyle} />
        <input type="email" placeholder="Email (facultatif)" value={email}
               onChange={(e) => setEmail(e.target.value)} autoComplete="email" style={inputStyle} />
        <input type="password" placeholder={`Mot de passe (min ${cfg?.min_password_len ?? 8} car., lettres + chiffres)`}
               value={p} onChange={(e) => setP(e.target.value)} required
               minLength={cfg?.min_password_len ?? 8}
               autoComplete="new-password" style={inputStyle} />
        {needsInvite && (
          <input placeholder="Code d'invitation (obligatoire)" value={invite}
                 onChange={(e) => setInvite(e.target.value)} required style={inputStyle} />
        )}
        {needsCaptcha && cfg?.captcha_sitekey && (
          <Turnstile sitekey={cfg.captcha_sitekey} onToken={setCaptcha} theme="dark" />
        )}
        {err && <div style={{ color: "#f87171" }}>{err}</div>}
        <button type="submit" className="btn primary" disabled={!canSubmit}>
          {busy ? "Création…" : "S'inscrire"}
        </button>
        <div className="muted" style={{ marginTop: 6, fontSize: 12 }}>
          En créant un compte tu acceptes nos <Link to="/terms">CGU</Link> et notre{" "}
          <Link to="/privacy">politique de confidentialité</Link>.
        </div>
        <div className="muted" style={{ marginTop: 6 }}>
          Déjà un compte ? <Link to="/login">Se connecter</Link>
        </div>
      </form>
    </AuthLayout>
  );
}
